<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader.vue";
import Button from "@/components/Button.vue";

export default {
    name: "SelectMaterial",
    props: { id_tipo_servico: Number },
    components: {
        Button,
        Loader,
    },
    data() {
        return {
            loader: false,
            show: false,
            list: [],
            material: [],
            q: ""
        };
    },
    methods: {
        ...mapActions("admin", ["MATERIAL_LIST", "MATERIAL_SERVICETYPE"]),
        async load() {
            let { data } = await this.MATERIAL_SERVICETYPE({ t: 'get', id: this.id_tipo_servico })
            if (data) this.list = data
        },
        async add(m) {
            this.q = ''
            let { data } = await this.MATERIAL_SERVICETYPE({ t: 'post', p: { id_tipo_servico: this.id_tipo_servico, id_material: m.id } })
            if (data) {
                this.list.unshift(data)
            }
        },
        async del(m, i) {
            this.list[i].loader = true
            this.list = [...this.list]
            let r = await this.MATERIAL_SERVICETYPE({ t: 'del', id: m.id })
            if (r && r.status == 200) this.list.splice(i, 1)
            this.list[i].loader = false
            this.list = [...this.list]
        }, close() {
            setTimeout(() => this.show = false, 200)
        }
    },
    mounted() {
        this.MATERIAL_LIST({}).then(({ data }) => { if (data) this.material = data })
        this.load()
    }
};
</script>

<template lang="pug">
.SelectMaterial
    h3.cw MATERIAIS
    .row.col-s
        .new.col.g4.g12-s
            input(v-model="q" @blur="close" @focus="show=true" placeholder="Adicionar")
            .select(v-if="show")
                .m.row(v-for="m in material.filter(m=>m.status=='ativo' && JSON.stringify(m).toLowerCase().includes(q))" @click="add(m)") 
                    b(style="flex:1") {{m.sku}} - {{m.nome}}
                    b +
        .list.col.g8.g12-s
            .head.cp.row.g12
                .g2 SKU
                .g4 Nome
                .g2 Unidade
                .g3
            .content
                .item.row.ac(v-for="item,i in list")
                    .g2 {{item.material.sku}}
                    .g4 {{item.material.nome}}
                    .g2 {{item.material.unidade=='unitario'?'Unitário':'Metro'}}
                    .g3.tr
                        Loader(v-if="item.loader" layout="mini")
                        i.fa.fa-trash(v-else @click="del(item,i)" title="Excluir")
</template>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.SelectMaterial
    @include page
    label
        @include label
    h3
        margin-bottom: 20px
        font-size: 26px
        border-radius: 4px
        padding: 10px
        background: linear-gradient(20deg, rgba($purple,.8), rgba(white,0))
    .item
        font-size: 14px
        color: $font-color
        padding: 12px 10px
        &:nth-child(even)
            background: #eee
        .fa-search
            margin-left: 6px
            margin-right: 20px
            &:hover
                color: $purple
        .fa-trash:hover
            color: $red
            font-size: 20px
            cursor: pointer
    .list
        margin: 0
        .head
            border-bottom: 1px solid $purple
            padding-bottom: 10px
            font-weight: bold
        .content
            max-height: 300px
            overflow: auto
            .loader
                margin: 0
    .new
        margin: 12px
        margin-left: 0
    .select
        border: 1px solid $purple
        margin-top: 4px
        border-radius: 8px
        font-size: 13px
        max-height: 290px
        overflow: auto
        .m
            padding: 8px 6px
            &:nth-child(even)
                background: #eee
            &:hover
                cursor: pointer
                background: rgba($purple,.5)
                color: white
</style>